import axios from 'axios';

// const API_URL = 'http://localhost:8080/api/v1';
// const API_URL = 'https://sandbox-api.gameupoficial.com/api/v1';
const API_URL = 'https://api.gameonbrasil.com/api/v1';

const RequestService = {
    setAuthHeader: (token) => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },

    forgotPassword: async (email) => {
        try {
            const response = await axios.post(
                `${API_URL}/auth/forgot-password`,
                {
                    email: email,
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao solicitar recuperação de senha:', error);
            throw error;
        }
    },

    validateResetToken: async (token) => {
        await axios.post(`${API_URL}/auth/validate-token`, null, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
    },

    resetPassword: async (token, newPassword) => {
        const response = await axios.post(
            `${API_URL}/auth/reset-password?token=${token}`,
            null,
            {
                params: { newPassword },
            }
        );
        return response.data;
    },

    resetPassword: async (token, newPassword) => {
        try {
            const response = await axios.post(
                `${API_URL}/auth/reset-password`,
                { newPassword },
                {
                    params: { token },
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error(
                'Erro ao redefinir senha:',
                error.response?.data || error.message
            );
            throw error;
        }
    },

    login: async (credentials) => {
        const response = await axios.post(
            `${API_URL}/auth/login-panel`,
            credentials
        );
        const data = response.data;

        // RequestService.setAuthHeader(token);

        return data;
    },

    logout: () => {
        delete axios.defaults.headers.common['Authorization'];
    },

    validateToken: async () => {
        try {
            const response = await axios.post(`${API_URL}/auth/validate-token`);
            return response.status === 202;
        } catch (error) {
            return false;
        }
    },

    getAdmins: async () => {
        try {
            const response = await axios.get(`${API_URL}/users/list/admins`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar administradores:', error);
            throw error;
        }
    },

    getDashboardData: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/companies/dashboard/${companyId}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar dados do dashboard:', error);
            throw error;
        }
    },

    getUsersByCompany: async (
        companyId,
        name = '',
        groupId = '',
        gameId = ''
    ) => {
        try {
            let url = `${API_URL}/users/company/${companyId}?`;

            if (name) url += `name=${encodeURIComponent(name)}&`;
            if (groupId) url += `groupId=${groupId}&`;
            if (gameId) url += `gameId=${gameId}`;

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar usuários da empresa:', error);
            throw error;
        }
    },

    selectUser: async (userId) => {
        try {
            const response = await axios.post(
                `${API_URL}/auth/select-user/${userId}`
            );
            const data = response.data;
            // RequestService.setAuthHeader(token);
            return data;
        } catch (error) {
            console.error('Erro ao selecionar o usuário:', error);
            throw error;
        }
    },

    addPlayer: async (playerData) => {
        try {
            const response = await axios.post(
                `${API_URL}/users/panel/create`,
                playerData
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao adicionar jogador:', error);
            throw error;
        }
    },

    editPlayer: async (payload) => {
        try {
            const response = await axios.put(
                `${API_URL}/users/update`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar jogador:', error);
            throw error;
        }
    },

    addCoinPlayer: async (isAdding, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/users/manage-coins?isAdding=${isAdding}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar jogador:', error);
            throw error;
        }
    },

    deletePlayer: async (playerId) => {
        try {
            const response = await axios.delete(`${API_URL}/users/${playerId}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir jogador:', error);
            throw error;
        }
    },

    getGroups: async (companyId, searchTerm = '', gameId = '') => {
        try {
            let url = `${API_URL}/groups/panel/${companyId}/groups`;

            const params = [];
            if (searchTerm)
                params.push(`name=${encodeURIComponent(searchTerm)}`);
            if (gameId) params.push(`gameId=${encodeURIComponent(gameId)}`);

            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar grupos:', error);
            throw error;
        }
    },

    createGroup: async (groupData) => {
        try {
            const response = await axios.post(`${API_URL}/groups`, groupData);
            return response.data;
        } catch (err) {
            console.error('Erro ao criar grupo:', err);
            throw err;
        }
    },

    updateGroup: async (groupId, groupData) => {
        try {
            const response = await axios.put(
                `${API_URL}/groups/${groupId}`,
                groupData
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao atualizar grupo:', err);
            throw err;
        }
    },

    deleteGroup: async (groupId) => {
        try {
            const response = await axios.delete(`${API_URL}/groups/${groupId}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir jogador:', error);
            throw error;
        }
    },

    addUsersToGroup: async (groupId, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/groups/${groupId}/users`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Error adding users to the group:', err);
            throw err;
        }
    },

    removeUsersFromGroup: async (groupId, payload) => {
        try {
            const response = await axios.delete(
                `${API_URL}/groups/${groupId}/users`,
                { data: payload }
            );
            return response.data;
        } catch (err) {
            console.error('Error removing users from the group:', err);
            throw err;
        }
    },

    createGame: async (payload) => {
        try {
            const response = await axios.post(`${API_URL}/games`, payload);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    updateGame: async (gameId, payload) => {
        try {
            const response = await axios.put(
                `${API_URL}/games/${gameId}`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao atualizar jogo:', err);
            throw err;
        }
    },

    getGames: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/games/company/${companyId}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    deleteGame: async (gameId) => {
        try {
            const response = await axios.delete(`${API_URL}/games/${gameId}`);
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir jogador:', error);
            throw error;
        }
    },

    getContents: async (
        companyId,
        name = '',
        groupId = '',
        gameId = '',
        type = ''
    ) => {
        try {
            let url = `${API_URL}/content/admin/${companyId}`;

            const params = [];
            if (name) params.push(`name=${encodeURIComponent(name)}`);
            if (groupId) params.push(`groupId=${encodeURIComponent(groupId)}`);
            if (gameId) params.push(`gameId=${encodeURIComponent(gameId)}`);
            if (type) params.push(`type=${encodeURIComponent(type)}`);

            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar conteúdos:', error);
            throw error;
        }
    },

    getNegativeContents: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/content/attitudes/negative/${companyId}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar atitudes negativas:', err);
            throw err;
        }
    },

    createContent: async (payload) => {
        try {
            const response = await axios.post(`${API_URL}/content`, payload);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    updateContent: async (contentId, payload) => {
        try {
            const response = await axios.put(
                `${API_URL}/content/${contentId}`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao atualizar conteúdo:', err);
            throw err;
        }
    },

    deleteContent: async (contentId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/content/${contentId}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir jogador:', error);
            throw error;
        }
    },

    getUserContents: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/content/contents/company/${companyId}/with-usercontents`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    createUserContent: async (id, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/usercontents/${id}/approve`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    getUserContentDetails: async (userContentId) => {
        try {
            const response = await axios.get(
                `${API_URL}/usercontents/${userContentId}/details`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    reviewUserContent: async (id, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/usercontents/${id}/review`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    createNegativeUserContent: async (payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/usercontents/negative-attitude`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    getProducts: async (storeId, name = '', gameId = '') => {
        try {
            let url = `${API_URL}/stock/store/${storeId}/products`;

            const params = [];
            if (name) params.push(`name=${encodeURIComponent(name)}`);
            if (gameId) params.push(`gameId=${encodeURIComponent(gameId)}`);

            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar produtos:', err);
            throw err;
        }
    },

    createProduct: async (productData) => {
        try {
            const response = await axios.post(
                `${API_URL}/products`,
                productData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao criar produto:', error);
            throw error;
        }
    },

    updateProduct: async (productId, productData) => {
        try {
            const response = await axios.put(
                `${API_URL}/products/${productId}`,
                productData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar o produto:', error);
            throw error;
        }
    },

    deleteProduct: async (productId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/products/${productId}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao deletar produto:', err);
            throw err;
        }
    },

    updateProductPublication: async (productId, published) => {
        const response = await axios.patch(
            `${API_URL}/products/${productId}/publication?published=${published}`
        );
        return response.data;
    },

    getPurchases: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/purchases/list/all?companyId=${companyId}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    approvePurchase: async (purchaseId, approve) => {
        try {
            const response = await axios.put(
                `${API_URL}/purchases/${purchaseId}/approve?approve=${approve}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    generateQrCode: async (companyId, userId) => {
        try {
            const response = await axios.get(
                `${API_URL}/companies/${companyId}/users/${userId}/generate-qr`,
                {
                    responseType: 'arraybuffer',
                }
            );

            return {
                data: btoa(
                    String.fromCharCode(...new Uint8Array(response.data))
                ),
            };
        } catch (error) {
            console.error('Erro ao gerar QR Code:', error);
            throw error;
        }
    },

    resetPoints: async (id, type, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/companies/${id}/reset-points/${type}`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao resetar pontos:', err);
            throw err;
        }
    },

    getCompanyAddress: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/companies/${companyId}/address`
            );
            return response.data;
        } catch (err) {
            if (err.response && err.response.status === 204) {
                return null;
            }
            console.error('Erro ao buscar endereço:', err);
            throw err;
        }
    },

    updateCompanyAddress: async (companyId, addressData) => {
        try {
            const response = await axios.post(
                `${API_URL}/companies/${companyId}/address`,
                addressData
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao atualizar endereço:', err);
            throw err;
        }
    },

    getCardsByCompany: async (companyId, status = null) => {
        try {
            let url = `${API_URL}/cards/${companyId}/cards`;
            if (status) {
                url += `?status=${status}`;
            }

            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar cartões:', err);
            throw err;
        }
    },

    assignCardToUser: async (cardCode, userId) => {
        try {
            let url = `${API_URL}/cards/${cardCode}/assign`;
            if (userId) {
                url += `?userId=${userId}`;
            }

            const response = await axios.post(url);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar cartões:', err);
            throw err;
        }
    },

    generateCardCodeAsAdmin: async (cardId) => {
        try {
            const response = await axios.get(`${API_URL}/admin/${cardId}/qr`, {
                responseType: 'arraybuffer',
            });

            return {
                data: btoa(
                    String.fromCharCode(...new Uint8Array(response.data))
                ),
            };
        } catch (error) {
            console.error('Erro ao gerar QR Code:', error);
            throw error;
        }
    },

    generateCardCode: async (cardId) => {
        try {
            const response = await axios.get(`${API_URL}/cards/${cardId}/qr`, {
                responseType: 'arraybuffer',
            });

            return {
                data: btoa(
                    String.fromCharCode(...new Uint8Array(response.data))
                ),
            };
        } catch (error) {
            console.error('Erro ao gerar QR Code:', error);
            throw error;
        }
    },

    bulkGenerateCards: async (companyId, quantity) => {
        try {
            const payload = {
                companyId: companyId,
                quantity: quantity,
            };
            const response = await axios.post(
                `${API_URL}/cards/generate-bulk`,
                payload
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao gerar cartões em massa:', error);
            throw error;
        }
    },

    getCompanyPhoto: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/companies/photo/${companyId}`
            );
            return response.data;
        } catch (err) {
            if (err.response && err.response.status === 204) {
                return null;
            }
            console.error('Erro ao buscar endereço:', err);
            throw err;
        }
    },

    updateCompanyPhoto: async (companyId, formData) => {
        const response = await axios.put(
            `${API_URL}/companies/${companyId}/photo`,
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );
        return response.data;
    },

    getCompanies: async () => {
        try {
            const response = await axios.get(`${API_URL}/admin/companies`);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar empresas:', error);
            throw error;
        }
    },

    createCompany: async (formData) => {
        try {
            const response = await axios.post(
                `${API_URL}/companies`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao criar empresa:', error);
            throw error;
        }
    },

    getCompanyAdmins: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/admin/company/${companyId}/admins`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar administradores da empresa:', error);
            throw error;
        }
    },

    createAdminForCompany: async (companyId, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/company/${companyId}/admins`,
                payload
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao criar administrador para a empresa:', error);
            throw error;
        }
    },

    deleteAdminFromCompany: async (adminId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/company/users/${adminId}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao remover administrador da empresa:', error);
            throw error;
        }
    },

    toggleCompanyStatus: async (companyId, active) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/company/${companyId}/status?active=${active}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao alterar status da empresa:', error);
            throw error;
        }
    },

    getCompanyAdminsFiltered: async (companyId, name = '', role = '') => {
        const params = new URLSearchParams();

        if (name && name.trim() !== '') {
            params.append('name', name.trim());
        }

        const response = await axios.get(
            `${API_URL}/admin/company/${companyId}/admins?${params.toString()}`
        );
        return response.data;
    },

    importAdminsFromExcel: async (formData) => {
        const response = await axios.post(
            `${API_URL}/admin/company/import-users`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );
        return response.data;
    },

    getCardsByCompanyAsAdmin: async (companyId, status = null) => {
        try {
            let url = `${API_URL}/admin/company/${companyId}/cards`;
            if (status) {
                url += `?status=${status}`;
            }
            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar cartões:', err);
            throw err;
        }
    },

    getCardsByCompany: async (companyId, status = null) => {
        try {
            let url = `${API_URL}/cards/${companyId}/cards`;
            if (status) {
                url += `?status=${status}`;
            }
            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar cartões:', err);
            throw err;
        }
    },

    bulkGenerateCards: async (companyId, quantity) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/company/${companyId}/cards/generate-bulk?quantity=${quantity}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao gerar cartões em massa:', error);
            throw error;
        }
    },

    deleteCard: async (cardId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/company/cards/${cardId}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao deletar cartão:', err);
            throw err;
        }
    },

    updateCompany: async (companyId, formData) => {
        try {
            const response = await axios.put(
                `${API_URL}/admin/company/${companyId}`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar empresa:', error);
            throw error;
        }
    },

    createContentAsSuperAdmin: async (company, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/company/${company}/contents`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    getContentsAsSuperAdmin: async (
        companyId,
        name = '',
        groupId = '',
        gameId = '',
        type = ''
    ) => {
        try {
            let url = `${API_URL}/admin/company/${companyId}/contents`;

            const params = [];
            if (name) params.push(`name=${encodeURIComponent(name)}`);
            if (groupId) params.push(`groupId=${encodeURIComponent(groupId)}`);
            if (gameId) params.push(`gameId=${encodeURIComponent(gameId)}`);
            if (type) params.push(`type=${encodeURIComponent(type)}`);

            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar conteúdos:', error);
            throw error;
        }
    },

    deleteContentAsSuperAdmin: async (contentId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/contents/${contentId}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir conteúdo:', error);
            throw error;
        }
    },

    getGroupsAsSuperAdmin: async (companyId, searchTerm = '', gameId = '') => {
        try {
            let url = `${API_URL}/admin/company/${companyId}/groups`;

            const params = [];
            if (searchTerm)
                params.push(`name=${encodeURIComponent(searchTerm)}`);
            if (gameId) params.push(`gameId=${encodeURIComponent(gameId)}`);

            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar grupos:', error);
            throw error;
        }
    },

    getGamesAsSuperAdmin: async (companyId) => {
        try {
            const response = await axios.get(
                `${API_URL}/admin/company/${companyId}/games`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    createGroupAsSuperAdmin: async (companyId, groupData) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/company/${companyId}/groups`,
                groupData
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao criar grupo:', err);
            throw err;
        }
    },

    updateGroupAsSuperAdmin: async (groupId, groupData) => {
        try {
            const response = await axios.put(
                `${API_URL}/groups/${groupId}`,
                groupData
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao atualizar grupo:', err);
            throw err;
        }
    },

    deleteGroupAsSuperAdmin: async (groupId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/groups/${groupId}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir jogador:', error);
            throw error;
        }
    },

    addUsersToGroupAsSuperAdmin: async (groupId, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/groups/${groupId}/users`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Error adding users to the group:', err);
            throw err;
        }
    },

    removeUsersFromGroupAsSuperAdmin: async (groupId, payload) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/groups/${groupId}/users`,
                { data: payload }
            );
            return response.data;
        } catch (err) {
            console.error('Error removing users from the group:', err);
            throw err;
        }
    },

    createGameAsSuperAdmin: async (companyId, payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/company/${companyId}/games`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar jogos:', err);
            throw err;
        }
    },

    updateGameAsSuperAdmin: async (gameId, payload) => {
        try {
            const response = await axios.put(
                `${API_URL}/admin/games/${gameId}`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao atualizar jogo:', err);
            throw err;
        }
    },

    deleteGameAsSuperAdmin: async (gameId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/games/${gameId}`
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao excluir jogador:', error);
            throw error;
        }
    },

    getProductsAsSuperAdmin: async (companyId, name = '', gameId = '') => {
        try {
            let url = `${API_URL}/admin/store/${companyId}/products`;

            const params = [];
            if (name) params.push(`name=${encodeURIComponent(name)}`);
            if (gameId) params.push(`gameId=${encodeURIComponent(gameId)}`);

            if (params.length > 0) {
                url += `?${params.join('&')}`;
            }

            const response = await axios.get(url);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar produtos:', err);
            throw err;
        }
    },

    createProductAsSuperAdmin: async (companyId, productData) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/company/${companyId}/products`,
                productData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao criar produto:', error);
            throw error;
        }
    },

    updateProductAsSuperAdmin: async (productId, productData) => {
        try {
            const response = await axios.put(
                `${API_URL}/admin/products/${productId}`,
                productData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar o produto:', error);
            throw error;
        }
    },

    deleteProductAsSuperAdmin: async (productId) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/products/${productId}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao deletar produto:', err);
            throw err;
        }
    },

    updateProductPublicationAsSuperAdmin: async (productId, published) => {
        const response = await axios.patch(
            `${API_URL}/admin/products/${productId}/publication?published=${published}`
        );
        return response.data;
    },

    getReviewedUserContentsWithFilters: async (
        companyId,
        { userId = '', groupId = '', approved = '', page = 0, size = 10 }
    ) => {
        try {
            let url = `${API_URL}/usercontents/list/company/${companyId}/reviewed?page=${page}&size=${size}`;
            if (userId) url += `&userId=${userId}`;
            if (groupId) url += `&groupId=${groupId}`;
            if (approved !== '') url += `&approved=${approved}`;

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar históricos de conteúdos:', error);
            throw error;
        }
    },

    getChallangers: async (companyId, { page = 0, size = 10 }) => {
        try {
            const response = await axios.get(
                `${API_URL}/challenges/panel/company/${companyId}?page=${page}&size=${size}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar desafios:', err);
            throw err;
        }
    },

    createChallenge: async (payload) => {
        try {
            const response = await axios.post(`${API_URL}/challenges`, payload);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar desafio:', error);
            throw error;
        }
    },

    deleteChallanger: async (id) => {
        try {
            const response = await axios.delete(`${API_URL}/challenges/${id}`);
            return response.data;
        } catch (err) {
            console.error('Erro ao excluir desafio:', err);
            throw err;
        }
    },

    getQuizzes: async (companyId, { page = 0, size = 10 }) => {
        try {
            const response = await axios.get(
                `${API_URL}/quiz/panel/company/${companyId}?page=${page}&size=${size}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar desafios:', err);
            throw err;
        }
    },

    createQuiz: async (payload) => {
        try {
            const response = await axios.post(`${API_URL}/quiz`, payload);
            return response.data;
        } catch (error) {
            console.error('Erro ao criar desafio:', error);
            throw error;
        }
    },

    updateQuiz: async (quizId, payload) => {
        try {
            const response = await axios.put(
                `${API_URL}/quiz/${quizId}`,
                payload
            );
            return response.data;
        } catch (error) {
            console.error('Erro ao criar desafio:', error);
            throw error;
        }
    },

    getQuizById: async (quizId) => {
        try {
            const response = await axios.get(`${API_URL}/quiz/panel/${quizId}`);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar desafios:', err);
            throw err;
        }
    },

    deleteQuizById: async (quizId) => {
        try {
            const response = await axios.delete(`${API_URL}/quiz/${quizId}`);
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar desafios:', err);
            throw err;
        }
    },

    generateQuizFromIa: async (payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/ai/generate`,
                payload
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar desafios:', err);
            throw err;
        }
    },

    getCompletedsPurchasesWithFilters: async (
        companyId,
        { userId = '', groupId = '', completed = '', page = 0, size = 10 }
    ) => {
        try {
            let url = `${API_URL}/purchases/list/${companyId}/completed?page=${page}&size=${size}`;
            if (userId) url += `&userId=${userId}`;
            if (groupId) url += `&groupId=${groupId}`;
            if (completed !== '') url += `&completed=${completed}`;

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error('Erro ao buscar históricos de conteúdos:', error);
            throw error;
        }
    },

    getQuizHistoryWithFilters: async (
        companyId,
        { userId, quizId, fromDate, toDate, page = 0, size = 10 }
    ) => {
        try {
            let url = `${API_URL}/quiz/history/company/${companyId}?page=${page}&size=${size}`;
            if (userId) url += `&userId=${userId}`;
            if (quizId) url += `&quizId=${quizId}`;

            if (fromDate)
                url += `&fromDate=${encodeURIComponent(fromDate)}T00:00:00`;
            if (toDate) url += `&toDate=${encodeURIComponent(toDate)}T23:59:59`;

            const { data } = await axios.get(url);
            return data;
        } catch (error) {
            console.error('Erro ao buscar histórico de quizzes:', error);
            throw error;
        }
    },

    adjustStock: async (payload) => {
        try {
            return await axios
                .patch(`${API_URL}/stock/adjust`, payload)
                .then((r) => r.data);
        } catch (err) {
            throw err;
        }
    },

    getPlansAsSuperAdmin: async (params = {}) => {
        const { page = 0, size = 10 } = params;
        try {
            const response = await axios.get(
                `${API_URL}/admin/plans?page=${page}&size=${size}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar planos:', err);
            throw err;
        }
    },

    createPlan: async (payload) => {
        try {
            const res = await axios.post(`${API_URL}/admin/plans`, payload);
            return res.data;
        } catch (err) {
            console.error('Erro ao criar plano');
            throw err;
        }
    },

    updatePlan: async (id, payload) => {
        try {
            const res = await axios.put(
                `${API_URL}/admin/plans/${id}`,
                payload
            );
            return res.data;
        } catch (err) {
            console.error('Erro ao editar o plano');
            throw err;
        }
    },

    deletePlanAsSuperAdmin: async (id) => {
        try {
            await axios.delete(`${API_URL}/admin/plans/${id}`);
        } catch (err) {
            console.error('Erro ao excluir plano');
            throw err;
        }
    },

    sendBroadcastNotification: async (payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/notifications/broadcast`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao enviar notificação em broadcast:', err);
            throw err;
        }
    },

    getEvents: async ({ page = 0, size = 10 }) => {
        try {
            const response = await axios.get(
                `${API_URL}/events?page=${page}&size=${size}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar eventos:', err);
            throw err;
        }
    },

    // getEvents: async (params) => {
    //     const { data } = await axios.get(`${API_URL}/events`, { params });
    //     return data;
    // },

    createEvent: async (formData) => {
        const { data } = await axios.post(`${API_URL}/events`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data;
    },

    updateEvent: async (eventId, formData) => {
        const { data } = await axios.put(
            `${API_URL}/events/${eventId}`,
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );
        return data;
    },

    deleteEvent: async (eventId) => {
        const { data } = await axios.delete(`${API_URL}/events/${eventId}`);
        return data;
    },

    getNotificationCampaigns: async ({ page = 0, size = 10 }) => {
        try {
            const response = await axios.get(
                `${API_URL}/admin/notification-campaigns?page=${page}&size=${size}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar campanhas de notificação:', err);
            throw err;
        }
    },

    getNotificationCampaignById: async (campaignId) => {
        try {
            const response = await axios.get(
                `${API_URL}/admin/notification-campaigns/${campaignId}`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao buscar campanha de notificação:', err);
            throw err;
        }
    },

    createNotificationCampaign: async (payload) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/notification-campaigns`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao criar campanha:', err);
            throw err;
        }
    },

    updateNotificationCampaign: async (id, payload) => {
        try {
            const response = await axios.put(
                `${API_URL}/admin/notification-campaigns/${id}`,
                payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao editar campanha:', err);
            throw err;
        }
    },

    deleteNotificationCampaign: async (id) => {
        try {
            const response = await axios.delete(
                `${API_URL}/admin/notification-campaigns/${id}`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao excluir campanha:', err);
            throw err;
        }
    },

    sendNotificationCampaign: async (campaignId) => {
        try {
            const response = await axios.post(
                `${API_URL}/admin/notification-campaigns/${campaignId}/send`
            );
            return response.data;
        } catch (err) {
            console.error('Erro ao enviar campanha de notificação:', err);
            throw err;
        }
    },
};

export default RequestService;
